// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    maintenance_find_maintenance_plans: 'Buscando entre los planes de mantenimiento',
    maintenance_maintenance_due: 'Mirando lo que toca',
    maintenance_maintenance_plan_file: 'Abriendo el plan',
    maintenance_maintenance_history: 'Leyendo el historial de revisiones',
    maintenance_complete_maintenance: 'Dando el mantenimiento por hecho',
  },
  ca: {
    maintenance_find_maintenance_plans: 'Cercant entre els plans de manteniment',
    maintenance_maintenance_due: 'Mirant el que toca',
    maintenance_maintenance_plan_file: 'Obrint el pla',
    maintenance_maintenance_history: 'Llegint l’historial de revisions',
    maintenance_complete_maintenance: 'Donant el manteniment per fet',
  },
  en: {
    maintenance_find_maintenance_plans: 'Looking through the maintenance plans',
    maintenance_maintenance_due: 'Checking what is due',
    maintenance_maintenance_plan_file: 'Opening the plan',
    maintenance_maintenance_history: 'Reading the service history',
    maintenance_complete_maintenance: 'Filing the maintenance as done',
  },
  fr: {
    maintenance_find_maintenance_plans: 'Recherche parmi les plans de maintenance',
    maintenance_maintenance_due: 'Ce qui est à faire',
    maintenance_maintenance_plan_file: 'Ouverture du plan',
    maintenance_maintenance_history: 'Lecture de l’historique d’entretien',
    maintenance_complete_maintenance: 'Enregistrement de la maintenance comme faite',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
